import SettingsPageHead from './settings-page-head.vue'
import LairdndProfileEdit from './lairdnd-profile-edit'
import LairdndAccountEdit from './lairdnd-account-edit'
import SettingsListing from './settings-listing'
import SettingsBookings from './settings-bookings'
import SettingsReviews from './settings-reviews'
import SettingsMessages from './settings-messages'
import SettingsPayouts from './settings-payouts'

export default {
    SettingsPageHead,
    LairdndProfileEdit,
    LairdndAccountEdit,
    SettingsListing,
    SettingsBookings,
    SettingsReviews,
    SettingsMessages,
    SettingsPayouts,
}
